/**
 * copy from element-ui
 */
import { withInstall } from '../utils'

import Com from './src/Scrollbar.vue'

export type { ScrollbarType } from './src/types'

export const Scrollbar = withInstall(Com)
